import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { HttpClient } from '../services/HttpClient';
import { HttpModule } from '@angular/http';

import { IonicStorageModule } from '@ionic/storage';

import { MyApp } from './app.component';
import { LoginPage } from '../pages/login/login';
import { DashboardPage } from '../pages/dashboard/dashboard';

import { ProfilePage } from '../pages/dashboard/profile/profile';

import { SlidesPage } from '../pages/dashboard/slides/slides';
import { AddSlidePage } from '../pages/dashboard/slides/addSlide/addSlide';
import { SlidePage } from '../pages/dashboard/slides/slide/slide';

import { UsersPage } from '../pages/dashboard/users/users';
import { UserPage } from '../pages/dashboard/users/user/user';
import { AddUserPage } from '../pages/dashboard/users/addUser/addUser';

import { ProjectsPage } from '../pages/dashboard/projects/projects';
import { ProjectPage } from '../pages/dashboard/projects/project/project';
import { AddProjectPage } from '../pages/dashboard/projects/addProject/addProject';

import { PublicationsPage } from '../pages/dashboard/publications/publications';
import { AddPublicationPage } from '../pages/dashboard/publications/addPublication/addPublication';
import { PublicationPage } from '../pages/dashboard/publications/publication/publication';

import { GroupsPage } from '../pages/dashboard/groups/groups';
import { AddGroupPage } from '../pages/dashboard/groups/addGroup/addGroup';
import { GroupPage } from '../pages/dashboard/groups/group/group';

import { NewsPage } from '../pages/dashboard/news/news';
import { AddNewPage } from '../pages/dashboard/news/addNew/addNew';
import { NewPage } from '../pages/dashboard/news/new/new';

import { OffersPage } from '../pages/dashboard/offers/offers';
import { AddOfferPage } from '../pages/dashboard/offers/addOffer/addOffer';
import { OfferPage } from '../pages/dashboard/offers/offer/offer';

import { ResearchLinesPage } from '../pages/dashboard/researchLines/researchLines';
import { AddResearchLinePage } from '../pages/dashboard/researchLines/addResearchLine/addResearchLine';
import { ResearchLinePage } from '../pages/dashboard/researchLines/researchLine/researchLine';

import { TrainingsPage } from '../pages/dashboard/trainings/trainings';
import { AddTrainingPage } from '../pages/dashboard/trainings/addTraining/addTraining';
import { TrainingPage } from '../pages/dashboard/trainings/training/training';

import { SeminarsPage } from '../pages/dashboard/seminars/seminars';
import { AddSeminaryPage } from '../pages/dashboard/seminars/addSeminary/addSeminary';
import { SeminaryPage } from '../pages/dashboard/seminars/seminary/seminary';

import { FilesPage } from '../pages/dashboard/files/files';
import { AddFilePage } from '../util/addFile/addFile';

import { ImageSelector } from '../util/imageSelector/imageSelector';

import { NotFoundPage } from '../util/notFound/notFound';

import { UserPublicationsPage } from '../pages/dashboard/users/user/publications/publications';

var components = [
    MyApp,
    LoginPage,
    
    DashboardPage,

    ProfilePage,

    SlidesPage,
    AddSlidePage,
    SlidePage,
    
    UsersPage,
    UserPage,
    AddUserPage,

    ProjectsPage,
    ProjectPage,
    AddProjectPage,

    PublicationsPage,
    AddPublicationPage,
    PublicationPage,

    GroupsPage,
    AddGroupPage,
    GroupPage,

    NewsPage,
    AddNewPage,
    NewPage,

    OffersPage,
    AddOfferPage,
    OfferPage,

    ResearchLinesPage,
    AddResearchLinePage,
    ResearchLinePage,

    TrainingsPage,
    AddTrainingPage,
    TrainingPage,

    SeminarsPage,
    AddSeminaryPage,
    SeminaryPage,

    FilesPage,
    AddFilePage,

    ImageSelector,

    NotFoundPage,
    UserPublicationsPage
];

@NgModule({
  declarations: components,
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp, {mode : 'md'}, {
      links : [
        { component : UsersPage , name : 'Usuarios', segment : 'users'},
        { component : UserPage , name : 'Usuario', segment : 'users/:id'},
        { component : ProjectsPage , name : 'Proyectos', segment : 'projects'},
        { component : ProjectPage , name : 'Proyecto', segment : 'projects/:id'},
        { component : PublicationsPage , name : 'Publicaciones', segment : 'publications'},
        { component : NewsPage , name : 'Noticias', segment : 'news'},
        { component : OffersPage , name : 'Ofertas', segment : 'offers'},
        { component : ResearchLinesPage , name : 'Departamentos', segment : 'researchlines'},
        { component : TrainingsPage , name : 'Formación', segment : 'trainings'},
        { component : SeminarsPage , name : 'Seminarios', segment : 'seminars'},
        { component : FilesPage , name : 'Archivos', segment : 'files'},
        { component : NotFoundPage , name : 'PageNotFound', segment : 'not-found-page'}
      ]
    }),
    IonicStorageModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: components,
  providers: [
    StatusBar,
    SplashScreen,
    HttpClient,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts